export enum ConsultationType {
    Consultation = 1,
    InConsultation = 2,
    AdministerVaccine = 3,
    InAdministerVaccine = 4,
    Invoice = 5,
    LabTest = 6
}

export enum ConsultationStep {
    InConsultation = 1,
    PatientDetails = 2,
    TripInformation = 3,
    MedicalConditions = 4,
    RecordPreviousVaccines = 5,
    SelectVaccination = 6,
    PrescribeVaccination = 7,
    SelectPrescriptions = 8,
    LabTests = 9,
    SaveAndPrint = 10,
    AdministerVaccine = 11,
    AdministerPatientDetails = 12,
    AdministerMedicalHistory = 13,
    AdministerVaccination = 15,
    ConfirmLabTests = 16,
    ConsultationComplete = 17,
    AdministerVaccineVisitComplete = 18,
    ConsultationCancelled = 19,
    ConsultationAndAdministerVaccineComplete = 20,
    InvoiceComplete = 21,
    LabtestOrderedOutsideOfConsultation = 22,
    HealthInformation = 23
}


export enum GroupConsultationStep {
    InConsultation = 1,
    TripInformation = 2,
    RecommendedDiseases = 3,
    RecommendedPrescriptions = 4,
    RecommendedLabTests = 5
}

export const ConsultationComplelte = [
    //ConsultationStep.ConsultationComplete,
    ConsultationStep.ConsultationCancelled,
    ConsultationStep.InvoiceComplete,
];

export const ConsultationStepInfo: Array<any> = [
    {
        step: ConsultationStep.PatientDetails,
        routerLink: '/consultation-process/patient-detail',
        name: 'Patient details'
    },
    {
        step: ConsultationStep.TripInformation,
        routerLink: '/consultation-process/trip-information',
        name: 'Trip information'
    },
    {
        step: ConsultationStep.MedicalConditions,
        routerLink: '/consultation-process/medical-conditions',
        name: 'Medical condition(s)'
    },
    {
        step: ConsultationStep.RecordPreviousVaccines,
        routerLink: '/consultation-process/record-previous-vaccines',
        name: 'Record previous vaccine(s)'
    },
    {
        step: ConsultationStep.SelectVaccination,
        routerLink: '/consultation-process/select-disease',
        name: 'Select disease(s)'
    },
    {
        step: ConsultationStep.PrescribeVaccination,
        routerLink: '/consultation-process/prescribe-vaccination',
        name: 'Prescribe vaccination(s)'
    },
    {
        step: ConsultationStep.SelectPrescriptions,
        routerLink: '/consultation-process/select-prescriptions',
        name: 'Select prescription(s)'
    },
    {
        step: ConsultationStep.LabTests,
        routerLink: '/consultation-process/lab-tests',
        name: 'Lab test(s)'
    },
    {
        step: ConsultationStep.SaveAndPrint,
        routerLink: '/consultation-process/save-consultation',
        name: 'Save'
    },
    {
        step: ConsultationStep.AdministerVaccine,
        routerLink: '/consultation-process/administer-vaccine',
        name: 'Administer Vaccination(s)'
    },
    {
        step: ConsultationStep.ConfirmLabTests,
        routerLink: '/consultation-process/confirmation-lab-tests',
        name: 'Confirm Lab Test(s)'
    },
    {
        step: 0,
        routerLink: 'consultation/waiting-room',
        name: ''
    }
];

export const GroupConsultationStepInfo: Array<any> = [
    {
        step: GroupConsultationStep.TripInformation,
        routerLink: '/consultation-process/trip-information',
        name: 'Trip information'
    },
    {
        step: GroupConsultationStep.RecommendedDiseases,
        routerLink: '/consultation-process/group-recommended-diseases',
        name: 'Recommended Disease(s)'
    },
    {
        step: GroupConsultationStep.RecommendedPrescriptions,
        routerLink: '/consultation-process/group-recommended-prescriptions',
        name: 'Recommended Prescription(s)'
    },
    {
        step: GroupConsultationStep.RecommendedLabTests,
        routerLink: '/consultation-process/group-recommended-lab-tests',
        name: 'Recommended Lab Test(s)'
    },
    {
        step: 0,
        routerLink: 'consultation/waiting-room',
        name: ''
    }
];

export const GroupTemplateConsultationStepInfo: Array<any> = [
    {
        step: GroupConsultationStep.TripInformation,
        routerLink: '/consultation-process/group-template-trip-information',
        name: 'Trip information'
    },
    {
        step: GroupConsultationStep.RecommendedDiseases,
        routerLink: '/consultation-process/group-template-recommended-diseases',
        name: 'Recommended Disease(s)'
    },
    {
        step: GroupConsultationStep.RecommendedPrescriptions,
        routerLink: '/consultation-process/group-template-recommended-prescriptions',
        name: 'Recommended Prescription(s)'
    },
    {
        step: GroupConsultationStep.RecommendedLabTests,
        routerLink: '/consultation-process/group-template-recommended-lab-tests',
        name: 'Recommended Lab Test(s)'
    },
    {
        step: 0,
        routerLink: 'consultation/waiting-room',
        name: ''
    }
];

export const ConsultationValue = [
    {
        colorName: "",
        consultationName: ""
    },
    {
        colorName: "consultation-status-01",
        consultationName: "Consultation"
    },
    {
        colorName: "consultation-status-02",
        consultationName: "In Consultation"
    },
    {
        colorName: "consultation-status-03",
        consultationName: "Administer Vaccine"
    },
    {
        colorName: "consultation-status-04",
        consultationName: "In Administer Vaccine"
    },
    {
        colorName: "consultation-status-05",
        consultationName: "Invoice"
    },
    {
        colorName: "consultation-status-06",
        consultationName: "Lab Test"
    }
];

export enum SaveTripType {
    DoNotSave = 0,
    Save = 1,
    CreateGroup = 2
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation/consultation.model.ts